export enum StatusIcons {
	Check = 'check',
	Cross = 'cross',
	Negotiated = 'negotiated',
	Awaiting = 'awaiting',
	Unavailable = 'unavailable',
}
